<template>
  <KernelIcon
    v-tooltip="'Admin'"
    name="verified-user-rounded"
    color="brand-coral"
  />
</template>
